module.exports = __webpack_public_path__ + "static/img/jnm-business-cert.4e52302.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jnm-business-cert.jpg
// module id = tWGp
// module chunks = 1